import { useDialog } from "@/utils/DialogProvider";
import React from "react";
import { ImagePreviewDialog } from "./ImageDialog";
// import Image from "next/image";

export const CustomImage = ({
  src,
  className,
  alt,
}: {
  src: string;
  alt?: string;
  className?: string;
}) => {
  const { openDialog } = useDialog();
  const myimg = src ? `/api/images/uploads/${src}` : "/image-placeholder.png";
  const image = myimg.replace(/\s/g, "");
  return (
    <img
      src={image}
      alt={alt ?? ""}
      className={className ?`${className} pointer` : "pointer"}
      onClick={(e) => {
        e.stopPropagation();
        openDialog("", <ImagePreviewDialog image={image} />);
      }}
    />
  );
};
